(ns manage.feed-mapping-table.hooks
  (:require [cljs-bean.core :refer [->clj]]
            [common.queries :refer [use-query]]
            [common.resource.query.product-store :as product-store.q]
            [common.util :refer [spread-obj]]
            [uix.core :as uix :refer [defhook]]
            [uix.re-frame :refer [use-subscribe]]))

(defn- get-product-store-fields [^js data]
  (->> data
       ->clj
       :fields
       (concat [{:name "sku" :type "keyword"}])))

(defhook use-product-store-fields []
  (let [{:keys [advertiser-id]} (use-subscribe [:url-context])
        mappings (use-subscribe [:form.feed-importer/value :raw-mappings])
        used-product-fields (->> mappings
                                 (filter :enabled)
                                 (map :to)
                                 set)
        {product-store-fields :data} (use-query (spread-obj (product-store.q/product-store-query
                                                             {:advertiser-id advertiser-id})
                                                            #js {:select get-product-store-fields}))]
    (uix/use-memo
     (fn []
       (->> product-store-fields
            (map #(hash-map :label (str (:name %) " (" (:type %) ")")
                            :value (:name %)
                            :disabled? (contains? used-product-fields (:name %))))))
     [used-product-fields product-store-fields])))
